import {processValue} from './TabHelpers.jsx';
import {includesAnyOf} from '@helpers/common/string.mjs';

export const Tabs1Description = ({
                                   tabDescriptionBodyValue,
                                   tabDescriptionTableValue,
                                   selectedVariant
                                 }) => {
  if (!tabDescriptionBodyValue) return null;
  // console.log('[Tabs1Description] selectedVariant:', selectedVariant);

  // Process compatibility notes to style links if present
  const processCompatibilityNotes = (notes) => {
    if (!notes) return notes;

    // Check if notes contain link tags
    if (notes.includes('<a href=')) {
      // Use pure inline styles as a fallback strategy with !important to override any conflicting styles
      return notes.replace(
        /<a href="([^"]+)">(.*?)<\/a>/g,
        (match, url, text) => {
          return `<a href="${url}" style="display: inline-block; padding: 1px 1px; color: #1d4ed8 !important; font-weight: 500; text-decoration: none;" target="_blank">${text}</a>`;
        }
      );
    }
    return notes;
  };

  let sections = tabDescriptionBodyValue?.split('\n')?.map((productRow) => String(productRow)?.trim())?.filter(Boolean);

  // Dynamically insert DescriptionTable after the second paragraph
  if (tabDescriptionTableValue) {
    // Check if compatibilityNotes exists in selectedVariant before attempting to use it
    const compatibilityNotes = selectedVariant?.compatibilityNotes ? processCompatibilityNotes(selectedVariant.compatibilityNotes) : null;
    sections.splice(1, 0, <DescriptionTable
      key={2}
      value={tabDescriptionTableValue}
      compatibilityNotes={compatibilityNotes}
    />);
  }

  return (
    <div>
      {sections?.map((productRow, index) => (
        <div
          key={index}
          className='my-2'
          style={index ? {} : {marginTop: 0}}
        >
          {productRow}
        </div>
      ))}
    </div>
  );
};

export const DescriptionTable = ({value, compatibilityNotes}) => {
  // console.log("[DescriptionTable] value:", value);
  // console.log("[DescriptionTable] compatibilityNotes:", compatibilityNotes);
  if (!value) return null;
  const json = typeof value === 'string' ? JSON.parse(value) : value;
  let quickFacts = Object.keys(json);
  // move these keys on top
  const keyIncludesSortOnTop = ['Model', 'Included'];
  quickFacts.sort((a, b) => (includesAnyOf(a, keyIncludesSortOnTop) ? -1 : 0));

  return (
    <div className='max-w-md mx-auto py-3'>
      <div className='relative overflow-hidden shadow-md sm:rounded-lg border'>
        <table className='min-w-full text-left overflow-x-auto'>
          <thead className='text-xs uppercase border dark:bg-gray-500'>
          <tr>
            <th
              className='px-2 py-2'
              style={{
                fontSize: '16px'
              }}
              colSpan='2'>
              Quick Facts
            </th>
          </tr>
          </thead>

          <tbody style={{fontSize: '15px'}}>
          {quickFacts?.map((key, index) => (
            <tr key={index} className='border-b dark:bg-gray-400 dark:border-gray-400'>
              {/* Left Column Below */}
              <td className='px-3 py-1 font-medium'>{key}</td>
              {/* Right Column Below */}
              <td>
                <div
                  className='pl-1'
                  dangerouslySetInnerHTML={{
                    __html: processValue(json[key])
                  }}
                />

                {/* Add compatibility note directly under the Vehicle Fit information */}
                {(key === 'Fits' || key === 'Vehicle Fit' || key === 'Vehicle Fits') && compatibilityNotes && (
                  <div
                    className='mt-1 mb-1 mr-1 px-0.5 py-0.5 text-xs text-gray-800 bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700 rounded'>
                    <div
                      className='font-semibold text-sm text-amber-900 dark:text-amber-300'>Compatibility
                      Note:
                    </div>
                    <div
                      className='leading-relaxed break-words'
                      style={{wordBreak: 'break-word', overflowWrap: 'break-word'}}
                      dangerouslySetInnerHTML={{
                        __html: compatibilityNotes
                      }}
                    />
                  </div>
                )}
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function DescriptionNotes({value}) {
  if (!value) {
    return null;
  }

  let sections = String(value).split('\n');
  sections = sections
    ?.map((productRow) => String(productRow)?.trim())
    ?.filter((productRow) => productRow);
  return (
    <div className='italic'>
      {sections?.map((productRow, index) => (
        <p key={index}>{productRow}</p>
      ))}
    </div>
  );
}
